import template from './adpPanelWithHeading.html';
import controller from './adpPanelWithHeading.controller';
import './adpPanelWithHeading.less';

let adpPanelWithHeadingComponent = {
  restrict: 'E',
  bindings: {},
  transclude: {
    header: '?panelHeader',
    content: '?panelContent'
  },
  template,
  controller
};

export default adpPanelWithHeadingComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpPanelWithHeading/adpPanelWithHeading.component.js